var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { inline: _vm.inline, myclass: _vm.myclass } },
    [
      _c(
        "el-form-item",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: {
            label: _vm.label === undefined ? "" : _vm.label + ":",
            prop: _vm.prop,
            "label-width": _vm.labelWidth,
            rules: _vm.myrules,
          },
        },
        [
          _vm._t("befor"),
          _vm._v(" "),
          _vm.myeditType !== "look"
            ? _c(
                "el-input",
                {
                  class: _vm.lookclass,
                  style: _vm.myinputWidth,
                  attrs: {
                    placeholder: _vm.myholder,
                    clearable: _vm.clearable,
                    type: _vm.type,
                    rows: _vm.rows,
                    maxlength: _vm.maxlength,
                    "show-word-limit": _vm.type === "textarea",
                    autosize: _vm.autosize,
                    disabled: _vm.disabled || _vm.myeditType === "disabled",
                    size: _vm.size,
                    readonly: _vm.readonly || _vm.myeditType === "readonly",
                  },
                  on: {
                    blur: _vm.blur,
                    clear: _vm.clear,
                    change: _vm.changex,
                    input: _vm.handleInput,
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onEnter($event)
                    },
                  },
                  model: {
                    value: _vm.currentValue,
                    callback: function ($$v) {
                      _vm.currentValue =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "currentValue",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon",
                    class: _vm.iconClass,
                    attrs: { slot: _vm.vslot },
                    slot: _vm.vslot,
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.myeditType === "look"
            ? _c(
                "div",
                {
                  staticClass: "v_input_look_div text_style",
                  style: _vm.myinputWidth,
                },
                [_vm._v(_vm._s(_vm.currentValue))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("after"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }